export const collectionInfoLookup = ({bucketsContent}) => (
    bucketsContent.map(({
        imageLarge,
        name,
        eventCount,
        id,
        displayCreatorName,
        creator,
        summary,
        creatorImageIdOverrideUrl,
    }) => ({
        imageLarge,
        name,
        eventCount,
        id,
        displayCreatorName,
        creator,
        summary,
        creatorImageIdOverrideUrl,
    }))
);
